import {
  MAX_FULL_NAME_LENGTH,
  MAX_NAME_LENGTH,
  MAX_PASSWORD_LENGTH,
  MIN_AGE,
  MIN_PASSWORD_LENGTH,
} from '@/constants/Common'
import { LocaleConstant } from '../en/constant'

const constant: LocaleConstant = {
  emailInvalid: 'Địa chỉ email không hợp lệ.',
  emailRequired: 'Email là bắt buộc.',
  passRequired: 'Mật khẩu là bắt buộc.',
  passNoWhiteSpace: 'Không được phép có khoảng trắng.',
  passMinLength: `Mật khẩu phải có ít nhất ${MIN_PASSWORD_LENGTH} ký tự.`,
  passMaxLength: `Mật khẩu không được vượt quá ${MAX_PASSWORD_LENGTH} ký tự.`,
  passLettersNumbers: 'Mật khẩu phải chứa cả chữ và số',
  passOneNumbers: 'Mật khẩu phải chứa ít nhất một số',
  passStrength: `Yêu cầu mật khẩu ít nhất ${MIN_PASSWORD_LENGTH} ký tự bao gồm sự kết hợp của chữ cái in hoa hoặc thường và số.`,
  passMatch: 'Vui lòng nhập mật khẩu khớp nhau.',
  fullNameRequired: 'Tên đầy đủ là bắt buộc.',
  fullNameNoSpecial: 'Không được sử dụng số hoặc ký tự đặc biệt.',
  fullNameNoWhitespace: 'Only whitespaces are not allowed.',
  fullNameMaxLength: `Chỉ cho phép ${MAX_FULL_NAME_LENGTH} ký tự`,
  nameMaxLength: `Chỉ được phép có ${MAX_NAME_LENGTH} ký tự`,
  typeDate: 'Định dạng ngày tháng nên là MM/DD/YYYY.',
  birthDateRequired: 'Ngày sinh là bắt buộc.',
  birthDateMin: `Độ tuổi tối thiểu là ${MIN_AGE} tuổi.`,
  emailConfirm: 'Email không khớp.',
  locationRequired: 'Vị trí là bắt buộc',
  locationNeedsCity: 'Vui lòng chọn một thành phố hoặc thị trấn. Chỉ chọn quốc gia là chưa đủ.',
  locationSaveFailed: 'Không thể sử dụng địa điểm này. Hãy thử lại hoặc chọn địa điểm khác.',
}

export default constant
